<script setup lang="ts">
import type { FastCheckoutMethod } from '@design-system/composables/useFastCheckoutMethods'
import { iconsMap } from './PdpEcommerceBlockProductFastCheckout.iconsMapping'

const LOGOS_ORDER: FastCheckoutMethod[] = ['applePay', 'googlePay', 'payPal']

const props = defineProps<{
  methods: FastCheckoutMethod[]
  disabled?: boolean
}>()

const emit = defineEmits<{
  click: []
}>()

const sortedMethods = computed(() =>
  LOGOS_ORDER.filter(method => props.methods.includes(method))
)

const { ts } = useI18n()
</script>

<template>
  <button
    type="button"
    class="border-primitives-black flex h-12 w-full items-center justify-between border px-4"
    :class="{ 'pointer-events-none opacity-50': disabled }"
    :aria-label="ts('pdp.fastCheckout.title')"
    aria-haspopup="dialog"
    data-testid="pdp-fast-checkout-logos"
    :disabled="disabled"
    @click="emit('click')"
  >
    <span class="text-book-6 text-neutral-black">{{
      $ts('pdp.fastCheckout.title')
    }}</span>
    <span class="flex items-center gap-3">
      <component
        :is="iconsMap[method]"
        v-for="method in sortedMethods"
        :key="method"
        aria-hidden="true"
      />
    </span>
  </button>
</template>
